import { GET_SURVEY_GROUPS, GET_PUBLIC_SURVEY_GROUPS } from '../../fetchTypes';
import {
  createDefaultRequestInitialState,
  createSelectorById,
  createSelectorByIdList,
  defaultRequestByIdReducer,
} from './withFetch';

const baseInitialState = {
  groupByGid: {},
};
const initialState = createDefaultRequestInitialState(baseInitialState);
export const actionDataToId = (data) => data.projectId;

const reducer = defaultRequestByIdReducer({
  actionDataToId,
  resultMapper: (data) => (data || {}).response || [],
  baseInitialState,
  extraOnSuccess: (state, projectId) => {
    const surveyGroups = state.byId[projectId].result;
    const nextState = { ...state, groupByGid: { ...state.groupByGid } };
    surveyGroups.forEach((g) => {
      nextState.groupByGid[g.gid] = g;
    });
    return nextState;
  },
});

export default (state = initialState, action) => {
  switch (action.fetchType) {
    case GET_SURVEY_GROUPS:
      return reducer(state, action);
    case GET_PUBLIC_SURVEY_GROUPS:
      return reducer(state, action);
    default:
      return state;
  }
};

const selfSelector = (state) => state.fetcher.surveyGroups;
export const selectFetcherSurveyGroups = selfSelector;
export const selectSurveyGroupsByProjectId = createSelectorById(selfSelector);
export const selectSurveyGroupsListByProjectIdList =
  createSelectorByIdList(selfSelector);
export const selectSurveyGroupByGid =
  (gid, stateSelector = selfSelector) =>
  (state) =>
    stateSelector(state).groupByGid[gid];
export const selectSurveyGroupListByGidList = (gidList) => (state) =>
  gidList.map((gid) => selectSurveyGroupByGid(gid)(state));
